/** Wrappers around the Cloudinary Image SDKs. */

import { Cloudinary } from '@cloudinary/url-gen';
import { auto } from '@cloudinary/url-gen/actions/resize';
import { AdvancedImage } from '@cloudinary/react';

const CLOUDINARY_CLOUD_NAME = 'adventurelist';

type CDNImageProps = {
    path: string;
    size: 'tiny' | 'small' | 'medium' | 'original';
};

export function getImageFromCDN({ path, size }: CDNImageProps) {
    const cld = new Cloudinary({ cloud: { cloudName: CLOUDINARY_CLOUD_NAME } });

    if (size === 'tiny') {
        return cld.image(path).format('auto').quality('auto').resize(auto().width(90).height(90));
    }
    if (size === 'small') {
        return cld.image(path).format('auto').quality('auto').resize(auto().width(200).height(200));
    }
    if (size === 'medium') {
        return cld.image(path).format('auto').quality('auto').resize(auto().width(500).height(500));
    }
    if (size === 'original') {
        return cld.image(path).format('auto').quality('auto');
    }

    return cld.image(path).format('auto').quality('auto');
}

/**
 * Gets the image from the CDN and renders it. `path` corresponds to the
 * `public_id` generated by Cloudinary (which we store in our database),
 * e.g. `visits_media/<something>`.
 */
export function CDNImage({ path, size }: CDNImageProps) {
    return <AdvancedImage cldImg={getImageFromCDN({ path, size })} />;
}
